import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  colspan: "6",
  class: "text-center py-4"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "popup-header" }
const _hoisted_5 = { class: "popup-header-main" }
const _hoisted_6 = { class: "popup-header-texts" }
const _hoisted_7 = { class: "popup-header-title" }
const _hoisted_8 = { class: "popup-header-meta" }
const _hoisted_9 = { class: "status-chip status-chip--draft" }
const _hoisted_10 = { class: "form-footer footer-modern px-6 py-3" }
const _hoisted_11 = { class: "footer-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_card, {
      elevation: "2",
      class: "admin-card"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card_title, { class: "card-title-row" }, {
          default: _withCtx(() => [
            _cache[8] || (_cache[8] = _createElementVNode("span", null, "Roluri Agenți (Hunter / Farmer)", -1)),
            _createVNode(_component_v_btn, {
              icon: "",
              color: "success",
              size: "small",
              variant: "elevated",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openDialog())),
              title: "Adaugă Rol Agent"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, { size: "20" }, {
                  default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                    _createTextVNode("mdi-plus", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_card_text, { class: "pa-0" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_table, { class: "admin-table" }, {
              default: _withCtx(() => [
                _cache[12] || (_cache[12] = _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", null, "Utilizator"),
                    _createElementVNode("th", null, "Tip Agent"),
                    _createElementVNode("th", null, "Data Start"),
                    _createElementVNode("th", null, "Data End"),
                    _createElementVNode("th", null, "Status"),
                    _createElementVNode("th", null, "Acțiuni")
                  ])
                ], -1)),
                _createElementVNode("tbody", null, [
                  (_ctx.loading)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_1, [
                        _createElementVNode("td", _hoisted_2, [
                          _createVNode(_component_v_progress_circular, {
                            indeterminate: "",
                            color: _ctx.APP_Color,
                            size: "24"
                          }, null, 8, ["color"])
                        ])
                      ]))
                    : (_ctx.agenti.length === 0)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_3, [...(_cache[9] || (_cache[9] = [
                          _createElementVNode("td", {
                            colspan: "6",
                            class: "text-center py-4 text-grey"
                          }, "Niciun agent configurat.", -1)
                        ]))]))
                      : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.agenti, (agent) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: agent.ID
                          }, [
                            _createElementVNode("td", null, [
                              _createElementVNode("strong", null, _toDisplayString(agent.Utilizator), 1)
                            ]),
                            _createElementVNode("td", null, [
                              _createVNode(_component_v_chip, {
                                color: agent.TipAgent === 'Hunter' ? 'deep-orange' : 'green',
                                size: "x-small"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(agent.TipAgent), 1)
                                ]),
                                _: 2
                              }, 1032, ["color"])
                            ]),
                            _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(agent.DataStart)), 1),
                            _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(agent.DataEnd) || '—'), 1),
                            _createElementVNode("td", null, [
                              _createVNode(_component_v_chip, {
                                color: _ctx.isActiv(agent) ? 'success' : 'default',
                                size: "x-small",
                                variant: "tonal"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.isActiv(agent) ? 'Activ' : 'Inactiv'), 1)
                                ]),
                                _: 2
                              }, 1032, ["color"])
                            ]),
                            _createElementVNode("td", null, [
                              _createVNode(_component_v_btn, {
                                icon: "",
                                size: "x-small",
                                variant: "text",
                                onClick: ($event: any) => (_ctx.openDialog(agent))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, { size: "16" }, {
                                    default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                                      _createTextVNode("mdi-pencil", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["onClick"]),
                              _createVNode(_component_v_btn, {
                                icon: "",
                                size: "x-small",
                                variant: "text",
                                color: "error",
                                onClick: ($event: any) => (_ctx.deleteAgent(agent))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, { size: "16" }, {
                                    default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                                      _createTextVNode("mdi-delete", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["onClick"])
                            ])
                          ]))
                        }), 128))
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.dialog,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.dialog) = $event)),
      "max-width": "480"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "popup-card-modern" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_v_icon, {
                  class: "popup-header-icon mr-3",
                  color: "primary"
                }, {
                  default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                    _createTextVNode("mdi-account-plus", -1)
                  ]))]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.form.ID ? 'Editare' : 'Adăugare') + " Rol Agent", 1),
                  _cache[14] || (_cache[14] = _createElementVNode("div", { class: "popup-header-subtitle" }, "Configurați responsabilitățile agentului în sistem", -1))
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.form.ID ? 'Modificare' : 'Nou'), 1)
              ])
            ]),
            _createVNode(_component_v_card_text, { class: "popup-body-modern px-6 py-4" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, { dense: "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_autocomplete, {
                          modelValue: _ctx.form.Utilizator,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.Utilizator) = $event)),
                          items: _ctx.utilizatoriDisponibili,
                          "item-title": "Username",
                          "item-value": "Username",
                          label: "Utilizator",
                          density: "compact",
                          variant: "outlined",
                          clearable: "",
                          loading: _ctx.loadingUtilizatori,
                          "no-data-text": "Niciun utilizator disponibil"
                        }, null, 8, ["modelValue", "items", "loading"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_select, {
                          modelValue: _ctx.form.TipAgent,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.TipAgent) = $event)),
                          items: ['Hunter', 'Farmer'],
                          label: "Tip Agent",
                          density: "compact",
                          variant: "outlined"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "12",
                      sm: "6"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field, {
                          modelValue: _ctx.form.DataStart,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.DataStart) = $event)),
                          label: "Data Start",
                          type: "date",
                          density: "compact",
                          variant: "outlined"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "12",
                      sm: "6"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field, {
                          modelValue: _ctx.form.DataEnd,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.DataEnd) = $event)),
                          label: "Data End (gol = activ indefinit)",
                          type: "date",
                          density: "compact",
                          variant: "outlined",
                          clearable: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_v_btn, {
                  variant: "outlined",
                  color: "success",
                  class: "mr-2",
                  onClick: _ctx.save,
                  loading: _ctx.saving,
                  style: {"text-transform":"none","font-weight":"600"}
                }, {
                  default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                    _createTextVNode("Salvează", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick", "loading"]),
                _createVNode(_component_v_btn, {
                  variant: "outlined",
                  color: "error",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.dialog = false)),
                  style: {"text-transform":"none","font-weight":"600"}
                }, {
                  default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                    _createTextVNode("Închide", -1)
                  ]))]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}